import { Department, DrinkFamily } from '../types/content'

export const departments: Department[] = [
  {
    id: 'fresh-fruits-vegetables',
    name: {
      nl: 'Verse groenten & fruit',
      en: 'Fresh fruit & vegetables',
    },
    detail: {
      nl: 'Kleurrijke producten, kruiden en elke dag versheid.',
      en: 'Colourful produce, herbs and daily freshness.',
    },
    image:
      'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'food-and-pantry',
    name: {
      nl: 'Kruidenierswaren',
      en: 'Food & pantry',
    },
    detail: {
      nl: 'Rijst, oliën, conserven, pasta en voorraadbasics.',
      en: 'Rice, oils, canned foods, pasta and pantry staples.',
    },
    image:
      'https://images.unsplash.com/photo-1601050690597-df0568f70950?auto=format&fit=crop&w=1400&q=95',
  },
  {
    id: 'electricals-and-appliances',
    name: {
      nl: 'Elektro & huishoudtoestellen',
      en: 'Electricals & appliances',
    },
    detail: {
      nl: 'Verlichting, elektronica, toestellen en accessoires.',
      en: 'Lighting, electronics, appliances and accessories.',
    },
    image:
      'https://images.unsplash.com/photo-1558002038-1055907df827?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'bedding-and-home-textiles',
    name: {
      nl: 'Bedtextiel & huishoudlinnen',
      en: 'Bedding & home textiles',
    },
    detail: {
      nl: 'Lakens, kussens, handdoeken en wooncomfort.',
      en: 'Bedsheets, pillows, towels and home comfort.',
    },
    image:
      'https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'diy-and-hardware',
    name: {
      nl: 'Doe-het-zelf & ijzerwaren',
      en: 'DIY & hardware',
    },
    detail: {
      nl: 'Gereedschap, herstelkits, verbouwing en tuin.',
      en: 'Tools, repair kits, home improvement and garden.',
    },
    image:
      'https://images.unsplash.com/photo-1452860606245-08befc0ff44b?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'health-and-medical',
    name: {
      nl: 'Gezondheid & parafarmacie',
      en: 'Health & medical',
    },
    detail: {
      nl: 'Eerste hulp, medisch materiaal en persoonlijke verzorging.',
      en: 'First aid, medical equipment and personal care.',
    },
    image:
      'https://images.unsplash.com/photo-1584515933487-779824d29309?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'school-and-library',
    name: {
      nl: 'School & boeken',
      en: 'School & library',
    },
    detail: {
      nl: 'Boeken, papierwaren, leren en bureaubenodigdheden.',
      en: 'Books, stationery, learning and office essentials.',
    },
    image:
      'https://images.unsplash.com/photo-1507842217343-583bb7270b66?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'kitchen-and-dining',
    name: {
      nl: 'Keuken & tafel',
      en: 'Kitchen & dining',
    },
    detail: {
      nl: 'Kookgerei, servies en praktische keukenbasics.',
      en: 'Cookware, tableware and practical kitchen essentials.',
    },
    image:
      'https://images.unsplash.com/photo-1556911220-e15b29be8c8f?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'meat-poultry-and-seafood',
    name: {
      nl: 'Slagerij, gevogelte & visafdeling',
      en: 'Meat, poultry & seafood',
    },
    detail: {
      nl: 'Verse stukken, gevogelte, vis en diepvriesselecties.',
      en: 'Fresh cuts, poultry, seafood and frozen selections.',
    },
    image:
      'https://images.unsplash.com/photo-1544943910-4c1dc44aab44?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'home-care-and-cleaning',
    name: {
      nl: 'Onderhoud & schoonmaak',
      en: 'Home care & cleaning',
    },
    detail: {
      nl: 'Wasmiddelen, schoonmaak, papierwaren en dagelijkse zorg.',
      en: 'Detergents, cleaning products, paper goods and daily care.',
    },
    image:
      'https://images.unsplash.com/photo-1583947215259-38e31be8751f?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'baby-and-pet-care',
    name: {
      nl: 'Baby & dieren',
      en: 'Baby & pet care',
    },
    detail: {
      nl: 'Babybasics, dierenvoeding en dagelijkse accessoires.',
      en: 'Baby essentials, pet nutrition and everyday accessories.',
    },
    image:
      'https://images.unsplash.com/photo-1589924691995-400dc9ecc119?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'automotive',
    name: {
      nl: 'Auto',
      en: 'Automotive',
    },
    detail: {
      nl: 'Motoroliën, pneus, accessoires en voertuigonderhoud.',
      en: 'Motor oils, tyres, vehicle accessories and maintenance products.',
    },
    image:
      'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'toys-sports-and-travel',
    name: {
      nl: 'Speelgoed, sport & reizen',
      en: 'Toys, sports & travel',
    },
    detail: {
      nl: 'Speelgoed, geschenken, fitness en reisartikelen.',
      en: 'Toys, gifts, fitness essentials and travel goods.',
    },
    image:
      'https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?auto=format&fit=crop&w=900&q=90',
  },
  {
    id: 'business-and-institutional-supply',
    name: {
      nl: 'Zakelijke & institutionele levering',
      en: 'Business & institutional supply',
    },
    detail: {
      nl: 'Assortimenten voor horeca, hotels, kantoren en instellingen.',
      en: 'Restaurant, hotel, office and institutional product ranges.',
    },
    image:
      'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=900&q=90',
  },
]

export const drinkFamilies: DrinkFamily[] = [
  {
    name: {
      nl: 'Mineraalwater',
      en: 'Mineral water',
    },
    detail: {
      nl: 'Plat · Sprankelend · Groot formaat',
      en: 'Still · Sparkling · Large format',
    },
    image:
      'https://images.unsplash.com/photo-1550505095-81378a674395?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Frisdranken',
      en: 'Soft drinks',
    },
    detail: {
      nl: 'Cola · Soda · Familieformaten',
      en: 'Cola · Soda · Family favourites',
    },
    image:
      'https://images.unsplash.com/photo-1629203851122-3726ecdf080e?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Sappen & nectars',
      en: 'Juices & nectars',
    },
    detail: {
      nl: 'Fruitsap · IJsthee · Smoothies',
      en: 'Fruit juice · Iced tea · Smoothies',
    },
    image:
      'https://images.unsplash.com/photo-1621506289937-a8e4df240d0b?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Koffie & thee',
      en: 'Coffee & tea',
    },
    detail: {
      nl: 'Koffie · Thee · Infusies · Cacao',
      en: 'Coffee · Tea · Infusions · Cocoa',
    },
    image:
      'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Energie & sport',
      en: 'Energy & sports',
    },
    detail: {
      nl: 'Energiedranken · Isotone dranken',
      en: 'Energy drinks · Isotonic refreshments',
    },
    image:
      'https://images.unsplash.com/photo-1622543925917-763c34d1a86e?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Wijn & schuimwijn',
      en: 'Wine & sparkling',
    },
    detail: {
      nl: 'Rood · Wit · Rosé · Feest',
      en: 'Red · White · Rosé · Celebration',
    },
    image:
      'https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Sterkedrank & whisky',
      en: 'Spirits & whisky',
    },
    detail: {
      nl: 'Whisky · Gin · Rum · Barbasics',
      en: 'Whisky · Gin · Rum · Bar essentials',
    },
    image:
      'https://images.unsplash.com/photo-1527281400683-1aae777175f8?auto=format&fit=crop&w=700&q=95',
  },
  {
    name: {
      nl: 'Horecaformaten',
      en: 'Hospitality packs',
    },
    detail: {
      nl: 'Geselecteerde formaten voor cafés en events',
      en: 'Selected formats for cafés and events',
    },
    image:
      'https://images.unsplash.com/photo-1513558161293-cdaf765ed2fd?auto=format&fit=crop&w=700&q=95',
  },
]
